import React from 'react';
import PropTypes from 'prop-types';
import { QuestionTypeViewPropTypes } from '../../utils';

const CheckboxLike = (props) => {
  const {
    valueChanged,
    value,
    question,
    component: Component,
    ...rest
  } = props;

  const { value: currentValue = [] } = value || {};

  const { attributes = {}, answers = [] } = question;

  const onChange = (itemKey, { checked }) => {
    let newValue;
    const isToggleNone = itemKey === attributes.toggleNone;
    const isToggleAll = itemKey === attributes.toggleAll;

    if (checked) {
      if (isToggleNone) {
        newValue = [itemKey];
      } else if (isToggleAll) {
        newValue = answers
          .map((a) => a.key)
          .filter((key) => key !== attributes.toggleNone);
      } else {
        newValue = [...currentValue, itemKey].filter(
          (v) => v !== attributes.toggleNone
        );
      }
    } else {
      newValue = currentValue.filter(
        (v) => v !== itemKey && v !== attributes.toggleAll
      );
    }

    valueChanged(newValue);
  };
  return (
    <Component
      {...rest}
      type="checkbox"
      valueChanged={onChange}
      value={value}
      question={question}
    />
  );
};

CheckboxLike.propTypes = {
  ...QuestionTypeViewPropTypes,
  component: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
};

export default CheckboxLike;
